import PlainModal, {
  PlainModalHeader,
  PlainModalContent,
  PlainModalFooter,
} from 'app/common/ui-next/plain-modal'

import ControlsBar from 'app/common/ui-next/controls-bar'
import PlainButton from 'app/common/ui-next/plain-button'
import PlainLabel from 'app/common/ui-next/plain-label'
import { PlainInputNumber } from 'app/common/ui-next/plain-input'

import styles from './KbzhuModal.module.scss'
import { PlainTextArea } from 'app/common/ui-next/plain-text-area'
import { useState } from 'react'

export const KbzhuModal = ({
  dishTitle,
  onClose,
  onSubmit,
}: {
  dishTitle: string
  onClose: () => void
  onSubmit: (props: {
    proteins: number
    fats: number
    carbohydrates: number
    caloric: number
    comment: string
  }) => Promise<boolean>
}) => {
  const [submitting, setSubmitting] = useState(false)

  const [proteins, setProteins] = useState('')
  const [fats, setFats] = useState('')
  const [carbohydrates, setCarbohydrates] = useState('')
  const [caloric, setCaloric] = useState('')
  const [comment, setComment] = useState('')

  const submitDisabled = !proteins || !fats || !carbohydrates || !caloric

  const handleSubmit = async () => {
    setSubmitting(true)
    console.log({
      proteins: parseFloat(proteins),
      fats: parseFloat(fats),
      carbohydrates: parseFloat(carbohydrates),
      caloric: parseFloat(caloric),
      comment,
    })
    const res = await onSubmit({
      proteins: parseFloat(proteins),
      fats: parseFloat(fats),
      carbohydrates: parseFloat(carbohydrates),
      caloric: parseFloat(caloric),
      comment,
    })
    setSubmitting(false)

    if (res) {
      onClose()
    }
  }

  return (
    <PlainModal show className={styles.root} formId="kbzhu" onSubmit={handleSubmit}>
      <PlainModalHeader onCrossClick={onClose}>{`КБЖУ «${dishTitle}»`}</PlainModalHeader>
      <PlainModalContent className={styles.contentLayout}>
        <div className={styles.info}>{'* Поля обязательные к заполнению'}</div>
        <div className={styles.mainValuesLayout}>
          <div className={styles.ordinalItem}>
            <PlainLabel htmlFor="proteins" skipUpperSpace displayAsBlock>
              {'Белки, г*'}
            </PlainLabel>
            <PlainInputNumber
              id="proteins"
              name="proteins"
              value={proteins}
              onValue={setProteins}
              step="0.01"
              wide
            />
          </div>
          <div className={styles.ordinalItem}>
            <PlainLabel htmlFor="fats" skipUpperSpace displayAsBlock>
              {'Жиры, г*'}
            </PlainLabel>
            <PlainInputNumber id="fats" name="fats" onValue={setFats} step="0.01" wide />
          </div>
          <div className={styles.ordinalItem}>
            <PlainLabel htmlFor="carbohydrates" skipUpperSpace displayAsBlock>
              {'Углеводы, г*'}
            </PlainLabel>
            <PlainInputNumber
              id="carbohydrates"
              name="carbohydrates"
              value={carbohydrates}
              onValue={setCarbohydrates}
              step="0.01"
              wide
            />
          </div>
          <div className={styles.caloricItem}>
            <PlainLabel htmlFor="caloric" skipUpperSpace displayAsBlock>
              {'Калорийность, ккал*'}
            </PlainLabel>
            <PlainInputNumber
              id="caloric"
              name="caloric"
              value={caloric}
              onValue={setCaloric}
              step="0.01"
              wide
            />
          </div>
        </div>
        <div>
          <PlainLabel htmlFor="description" skipUpperSpace displayAsBlock>
            {'Описание'}
          </PlainLabel>
          <PlainTextArea
            rows={5}
            id="description"
            name="description"
            value={comment}
            onChange={(e) => setComment(e.currentTarget.value)}
          />
        </div>
      </PlainModalContent>

      <PlainModalFooter>
        <ControlsBar right>
          <PlainButton outline onClick={onClose}>
            {'Отмена'}
          </PlainButton>
          <PlainButton type="submit" disabled={submitDisabled || submitting}>
            {'Подтвердить'}
          </PlainButton>
        </ControlsBar>
      </PlainModalFooter>
    </PlainModal>
  )
}
